import XMultiselect from './XMultiselect'
export default XMultiselect
